export enum CoinTypeEnum {
  PAID = 'PAID',
  FREE = 'FREE',
}
